<script>import { attrValue } from "../../utils/html";
export let type = "indeterminate";
export let appearance = "circular";
export let color = "primary";
export let progress = 0;
export let classNames = "";
export let size = "default";
export let text;
</script>

{#if appearance === 'circular'}
	<div class="inline-block overflow-hidden p-1">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 21 21"
			class={attrValue([size, classNames, `animate-spin text-${color}`])}
		>
			<circle class="opacity-25" cx="10.5" cy="10.5" r="10" fill="none" stroke="currentColor" />
			<path d="M10.5 20.5c-5.5 0-10-4.5-10-10S5 .5 10.5.5" fill="none" stroke="currentColor" />
		</svg>
	</div>
{:else if appearance === 'text'}
	<div class="blinking-dots">
		<span>{text}</span>
		<span class="blinking-dot">.</span>
		<span class="blinking-dot">.</span>
		<span class="blinking-dot">.</span>
	</div>
{:else if type === 'indeterminate'}
	<div class="progress-bar progress-bar__indeterminate relative h-1 overflow-hidden" />
{:else}
	<div class="progress-bar progress-bar__determinate relative h-1 overflow-hidden">
		<div class="bg-primary h-full" style="width: {progress}%;" />
	</div>
{/if}

<style>.tiny{height:.5rem;width:.5rem}.small{height:1rem;width:1rem}.default{height:1.5rem;width:1.5rem}.big{height:2rem;width:2rem}.huge{height:3rem;width:3rem}@keyframes indeterminate{0%{left:-35%;right:100%}60%{left:100%;right:-90%}to{left:100%;right:-90%}}@keyframes determinate{0%{width:0}to{width:100%}}@keyframes indeterminate-short{0%{left:-200%;right:100%}60%{left:107%;right:-8%}to{left:107%;right:-8%}}.progress-bar{background-color:var(--color-primary-light)}.progress-bar:after,.progress-bar:before{background-color:var(--color-primary);bottom:0;content:"";left:0;position:absolute;top:0;will-change:left,right}.progress-bar__determinate{animation-name:determinate}.progress-bar__indeterminate:before{animation:indeterminate 2.1s cubic-bezier(.65,.815,.735,.395) infinite}.progress-bar__indeterminate:after{animation:indeterminate-short 2.1s cubic-bezier(.165,.84,.44,1) infinite;animation-delay:1.15s}@keyframes blink{0%{opacity:.2}20%{opacity:1}to{opacity:.2}}.blinking-dot{animation-duration:1.4s;animation-fill-mode:both;animation-iteration-count:infinite;animation-name:blink;display:inline}.blinking-dot:nth-child(3){animation-delay:.2s}.blinking-dot:nth-child(4){animation-delay:.4s}</style>
